import { ProjectTasksPage } from "@/features/projects/project-tasks.page";
import { isProjectFeatureEnabled } from "@/features/projects/utils/project-features";
import { projectHomeRedirect } from "@/features/projects/utils/project-home-destination";
import { IncognitoProjectTasksPage } from "@/features/superuser/incognito/project/incognito-project-tasks.page";
import { useWorkspaceAccess } from "@/features/workspaces/use-workspace-access";
import { ProjectRoute } from "@/routes/_authenticated/workspaces/$slug/projects/$projectSlug";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/tasks",
)({
  beforeLoad: ({ context, params }) => {
    if (!isProjectFeatureEnabled(context.project, "show_tasks")) {
      // CR-144: straight to the project's resolved home, not the bare root.
      throw projectHomeRedirect(context.project, params, context.workspaceAccess);
    }
  },
  component: ProjectTasksPageRoute,
});

// CR-165: incognito mode gets the display-only board (no drag, no realtime
// subscription, no membership reads); the member page is untouched.
function ProjectTasksPageRoute() {
  const workspaceAccess = useWorkspaceAccess();
  const { project } = ProjectRoute.useRouteContext();

  if (workspaceAccess.mode === "incognito") {
    return <IncognitoProjectTasksPage project={project} />;
  }

  return <ProjectTasksPage />;
}
